// import { auth } from "../config/firebase";
import { tools } from "../tools/tools";
import { StatusChangeOptions } from "../types/enums";
import { axiosService } from "./axios.service";

interface RequestDetails {
  trackMasterNotesInformation?: string;
  trackMasterCommunicationChannels?: string;
  trackMasterTypeOfFraud?: string;
  trackMasterFraudUrl?: string;
}

interface ToolInfoItem {
  Created_Time: string;
  contractSigned: boolean;
  data: any[];
  deals: any[];
  id: string;
  leftToPay: number | null;
  link: string;
  paid: number;
  productRequestType: string;
  requestDetails: RequestDetails;
  resultFile: string | null;
  status: string;
  totalAmount: number | null;
}

type ToolInfoResponse = ToolInfoItem[];

const BASE_URL = import.meta.env.VITE_BACKEND_URL;

//POST /toolname/:user_id —> Send form request to relevant agent.
export const sendToolRequest = async (
  formData: any,
  toolname: string,
  toolObj: string,
  isFormData: boolean,
  endpoint?: string
) => {
  try {
    const url = endpoint
      ? `${BASE_URL}/${toolname}/${endpoint}`
      : `${BASE_URL}/${toolname}`;
    // // const token = await auth.currentUser?.getIdToken();
    if (!isFormData) {
      const response: any = await axiosService.post(url, {
        [toolObj]: { ...formData, type: endpoint },
      });

      if (!response.data) {
        throw new Error("Something went wrong.");
      }
      return response;
    } else {
      const response: any = await axiosService.post(
        `${BASE_URL}/${toolname}`,
        formData
      );
      if (!response.data) {
        throw new Error("Something went wrong.");
      }
      return response;
    }
  } catch (error) {
    return error;
  }
};
export const sendCorrespondenceResponse = async (input: string, id: string) => {
  try {
    // const token = await auth.currentUser?.getIdToken();
    // if (!token) {
    //   throw new Error("User is not authenticated");
    // }

    const payload = {
      correspondence: { responseText: input },
    };

    const response: any = await axiosService.post(
      `${BASE_URL}/correspondence/response/${id}`,
      payload
    );

    return response.data;
  } catch (error) {
    console.error("Error sending correspondence response:", error);
    throw error;
  }
};

export const getToolInfo = async (
  toolname: string,
  page?: number,
  limit?: number
): Promise<ToolInfoResponse> => {

    let url = `${BASE_URL}/${toolname}`;

    if (page !== undefined && limit !== undefined) {
      url += `?page=${page}&limit=${limit}`;
    }

    const response = await axiosService.get<ToolInfoResponse>(url);

    if (!response) {
      throw new Error("Something went wrong.");
    }
    return response;

};
// GET /toolame/:user_id/:session_id —> Return information from trackmaster DB.
export const getToolInfoSession = async (
  toolname: string,
  sessionID: string,
  page?: number,
  limit?: number
) => {
  try {
    console.log("toolname: ", toolname);
    console.log("sessionID: ", sessionID);
    // const token = await auth.currentUser?.getIdToken();
    // console.log("token: ", token);
    let url = `${BASE_URL}/${toolname}/${sessionID}`;

    if (page !== undefined && limit !== undefined) {
      url += `?page=${page}&limit=${limit}`;
    }

    const response: any = await axiosService.get(url);
    if (!response) {
      throw new Error("Something went wrong.");
    }
    return response;
  } catch (error) {
    return error;
  }
};

export const getAllToolInfo = async () => {
  try {
    // const token = await auth.currentUser?.getIdToken();
    const response: any = await axiosService.get(
      `${BASE_URL}/user/product-requests`
    );
    if (!response.data) {
      throw new Error("Something went wrong.");
    }
    return response.data;
  } catch (error) {
    return error;
  }
};

export const createRefundRequest = async (
  tool: string,
  productRequestId: string,
  refundRequestType: string,
  reason: string
) => {
  const refundRequest = {
    tool: tool.toUpperCase().replace(" ", "_"),
    productRequestId,
    refundRequestType,
    reason,
    status: "Pending",
  };
  // const token = await auth.currentUser?.getIdToken();
  const response: any = await axiosService.post(`${BASE_URL}/refund`, {
    refundRequest,
  });
  if (response.status !== 201) {
    throw new Error("Something went wrong.");
  }
  return response;
};

export const getRefundRequests = async () => {
  try {
    // const token = await auth.currentUser?.getIdToken();
    const response: any = await axiosService.get(`${BASE_URL}/refund`);
    if (!response.data) {
      throw new Error("Something went wrong.");
    }
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getProcessesStatusCount = async () => {
  try {
    // const token = await auth.currentUser?.getIdToken();
    const { data }: any = await axiosService.get(
      `${BASE_URL}/user/product-requests-status-count`
    );
    if (!data) {
      throw new Error("Something went wrong.");
    }
    return data;
  } catch (error) {
    return error;
  }
};

export const createNotification = async (
  message: string
  //  password: string
) => {
  try {
    // const token = password;
    const notification = { message };
    const response: any = await axiosService.post(`${BASE_URL}/notification`, {
      notification,
    });
    if (!response.data) {
      throw new Error("Something went wrong.");
    }
    return response;
  } catch (error) {
    return error;
  }
};

export const createUserNotification = async (
  message: string,
  password: string,
  userID: string
) => {
  try {
    // const token = password;
    const notification = { message };
    const response: any = await axiosService.post(
      `${BASE_URL}/notification/${userID}`,
      { notification }
    );
    if (!response.data) {
      throw new Error("Something went wrong.");
    }
    return response;
  } catch (error) {
    return error;
  }
};

export const getUserNotification = async () => {
  try {
    // const token = await auth.currentUser?.getIdToken();
    const response: any = await axiosService.get(`${BASE_URL}/notification`);
    if (!response.data) {
      throw new Error("Something went wrong.");
    }
    return response.data;
  } catch (error) {
    return error;
  }
};

export const declineCallRequest = async (notificationId: string) => {
  try {
    // const token = await auth.currentUser?.getIdToken();
    await axiosService.delete(
      `${BASE_URL}/notification/delete/${notificationId}`
    );
  } catch (error) {
    console.log(error);
    throw new Error("Something went wrong.");
  }
};

export const handleFinishProcess = async (
  userId: string,
  processId: string,
  tool: string,
  password: string,
  formData: any
) => {
  try {
    // const token = password;

    // const config = {
    //   headers: { "content-type": "multipart/form-data", Authorization: token },
    // };
    const response: any = await axiosService.put(
      `${BASE_URL}/${tool}/${userId}/${processId}/finish-process`,
      formData
    );

    if (!response.data) {
      throw new Error("Something went wrong.");
    }
    return response;
  } catch (error) {
    return { error };
  }
};

export const changeProcessStatus = async (
  userId: string,
  processId: string,
  tool: string,
  //   password: string,
  status: string,
  info: string | number
) => {
  try {
    // const token = password;

    const toolToSend = tools.find(
      (toolToCheck) => toolToCheck.ToolNameBackend == tool
    );
    if (!toolToSend) throw new Error("No tool Found, please try again");

    if (status == StatusChangeOptions.WAITING_FOR_PAYMENT) {
      const response: any = await axiosService.put(
        `${BASE_URL}/${toolToSend.id}/${userId}/${processId}/change-process-status`,
        { status, cost: Number(info) }
      );
      return response;
    } else if (status == StatusChangeOptions.REJECTED) {
      const response: any = await axiosService.put(
        `${BASE_URL}/${toolToSend.id}/${userId}/${processId}/change-process-status`,
        { status, reason: info }
      );
      return response;
    }
  } catch (error) {
    return { error };
  }
};

export const getProcessLinkWhenDone = async (
  tool: string,
  processId: string
) => {
  try {
    // const token = await auth.currentUser?.getIdToken();
    const toolToSend = tools.find((toolToCheck) => toolToCheck.id == tool);
    return await axiosService.get(
      `${BASE_URL}/${toolToSend?.id}/${processId}/file`
    );
  } catch (error) {
    return { error };
  }
};

export const getFilteredBrandReviews = async (
  filter: string = "",
  page: number,
  limit: number
) => {
  try {
    // const token = await auth.currentUser?.getIdToken();

    const data = await axiosService.get(
      `${BASE_URL}/brand-reviews/scam-filter/${page}/${limit}/${filter}`
    );

    return data?.data;
  } catch (error) {
    console.log(error);
    // toast.error(error.response.data.message)
    return error;
  }
};

export const getAllUsers = async () => {
  try {
    // const token = await auth.currentUser?.getIdToken();

    const data = await axiosService.get(`${BASE_URL}/user/all`);

    return data?.data;
  } catch (error) {
    console.log(error);
    // toast.error(error.response.data.message)
    return error;
  }
};

export const getAllUsersByEmailContaining = async (partialEmail: string) => {
  try {
    // const token = await auth.currentUser?.getIdToken();
    const data = await axiosService.get(
      `${BASE_URL}/user/by-email-contain/${partialEmail}`
    );
    return data?.data;
  } catch (error) {
    console.log(error);
  }
};

export const getAllLogsById = async (id: string) => {
  try {
    // const token = await auth.currentUser?.getIdToken();

    const data = await axiosService.get(`${BASE_URL}/logs/${id}`);

    return data?.data;
  } catch (error) {
    console.log(error);
    // toast.error(error.response.data.message)
    return error;
  }
};

export const getAllIpTrackers = async (userIds: string) => {
  try {
    // const token = await auth.currentUser?.getIdToken();
    const data = await axiosService.get(
      `${BASE_URL}/track-master/all/${userIds}`
    );
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const readNotifications = async (
  userId: string,
  readUserNotifications: string[],
  readGlobalNotifications: string[]
) => {
  try {
    // const token = await auth.currentUser?.getIdToken();
    const readNotification = {
      userId: userId,
      globalNotificationId: readGlobalNotifications,
      userNotificationId: readUserNotifications,
    };
    const data = await axiosService.put("/notification/read-message", {
      readNotification,
    });
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const setNotificationSettings = async (
  userId: string,
  general: boolean,
  personal: boolean
) => {
  try {
    // const token = await auth.currentUser?.getIdToken();
    const requestData = {
      userId: userId,
      general: general,
      personal: personal,
    };
    const data = await axiosService.put(
      "/user/notification-settings",
      requestData
    );
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};
export const getHibpData = async (email: string) => {
  try {
    // const token = await auth.currentUser?.getIdToken();
    const data = await axiosService.get(`${BASE_URL}/webhook/hibp/${email}`);
    return data.data;
  } catch (error: any) {
    console.log(error.response.data);
    return error.response.data;
  }
};
